import { useEffect } from 'react';

/** Public pages scroll; the desktop app does not. Toggle the body mode while mounted. */
export function usePubBody(): void {
  useEffect(() => {
    document.body.classList.add('pub-mode');
    return () => { document.body.classList.remove('pub-mode'); };
  }, []);
}

/** Asset under the app's base path (public/ is served at import.meta.env.BASE_URL). */
export const asset = (name: string): string => `${import.meta.env.BASE_URL}${name}`;
